"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@material-ui/core/styles");
const Typography_1 = require("@material-ui/core/Typography");
const classnames_1 = require("classnames");
const CardBannerStyles_1 = require("./jss/CardBannerStyles");
const CardBanner = ({ classes, text, styleType }) => {
    const cardBannerHeaderClasses = (0, classnames_1.default)({
        [classes.cardBanner]: true,
        [classes['cardBanner' + styleType]]: !!styleType
    });
    const cardBannerTextClasses = (0, classnames_1.default)({
        [classes['cardBannerContent' + styleType]]: !!styleType
    });
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: cardBannerHeaderClasses }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ className: cardBannerTextClasses, variant: "overline" }, { children: text })) })));
};
exports.default = (0, styles_1.withStyles)(CardBannerStyles_1.default)(CardBanner);
//# sourceMappingURL=CardBanner.js.map